"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _user = require("@/api/admin/user/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      options: [{
        name: "新增",
        class: "editor",
        option: "addLogo",
        span: 3
      }, {
        name: "编辑",
        class: "editor",
        option: "editLogo",
        span: 3
      }, {
        name: "配置项",
        class: "editor",
        option: "configSet",
        span: 3
      }],
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "编码",
        prop: "uniqueCode",
        isShow: true,
        width: "100"
      }, {
        name: "省份",
        prop: "name",
        isShow: true,
        width: "150"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      name: "",
      checkBoxs: []
    };
  },
  methods: {
    //查看配置项
    configSet: function configSet(row) {
      this.$router.push({
        path: "/webSet/config",
        query: {
          title: row.name,
          id: row.id,
          businessId: row.businessId
        }
      });
    },
    // 查看管理员
    entryList: function entryList(e) {
      this.$router.push({
        path: "/province/provinceAdminList",
        query: {
          title: e.name,
          id: e.id
        }
      });
    },
    // 搜索框
    search: function search(v) {
      console.log(v);
      this.name = v.queryValue;
      this.getProvinceList();
    },
    // 编辑按钮操作
    editLogo: function editLogo(row) {
      this.$router.push({
        path: "/webSet/logoEdit",
        query: {
          id: row.id
        }
      });
    },
    // 新增按钮操作
    addLogo: function addLogo(e) {
      this.$router.push({
        path: "/webSet/logoAdd",
        query: {
          id: e.id
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(row) {
      var _this = this;
      this.checkBoxs = [];
      row.forEach(function (item) {
        _this.checkBoxs.push(item.id);
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getProvinceList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getProvinceList();
    },
    // 获取省份列表
    getProvinceList: function getProvinceList() {
      var _this2 = this;
      (0, _user.getProvince)({
        name: this.name,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        uniqueCode: ""
      }).then(function (res) {
        var data = res.data;
        _this2.totalData = data.total;
        _this2.listData = data.list;
      }).catch(function (e) {
        return e;
      });
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.getProvinceList();
  }
};